import { Button, Card, Col, Row } from "react-bootstrap";
import CardTiketsOverview from "./cards-tickets/CardTicketsOverview";
import React, { useEffect, useState } from "react";
import {getCuotasRange } from "data/apiConection.js/dataCuotas";
import CardRendimientoPRC from "./cards-pagos/CardRendimientoPRC";
import CardDates from "./cards-pagos/CardDates";
import { FaPrint } from "react-icons/fa";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
const Reportes = () => {
    const [ cuotas , setCuotas ] = useState([]);
    const [ desde , setDesde ] = useState('2025-06-03');
    const [ hasta , setHasta ] = useState('2025-08-28');
    useEffect( () => {
        const fetchCuotasRange = async () => {
            try {
                if(desde && hasta){
                    const c = await getCuotasRange(desde,hasta);
                    if (c) setCuotas(c);
                    console.log(c);
                }
              
            } catch (error) {
                console.error("Error fetching cuotas range",error);
            }
        }
        fetchCuotasRange()
    },[desde,hasta])
const handle_button_print_data = (cuotas, desde, hasta) => {
  if (cuotas && desde && hasta) {
    const object_print = {
      fecha_desde: desde,
      fecha_hasta: hasta,
      monto_credito: cuotas.monto_credito || 0,
      monto_debito: cuotas.monto_debito || 0,
      monto_efectivo: cuotas.monto_efectivo || 0,
      monto_transferencia: cuotas.monto_transferencia || 0,
      monto_pagos_tic: cuotas.monto_pagos_tic || 0,
    };
    export_to_excel([object_print]);
  }
};

const export_to_excel = (dataArray) => {
  if (dataArray?.length) {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(dataArray);

    XLSX.utils.book_append_sheet(workbook, worksheet, "Reportes");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "reportes.xlsx");
  }
};

    return(
        <Card>
            <Card.Header>
                <h4>{"Reportes"}</h4>
                <Row><Col className="text-end"><Button onClick={() => handle_button_print_data(cuotas,desde,hasta)}><FaPrint /></Button></Col></Row>
            </Card.Header>
            <Card.Body>
                 <Row className="mb-3">
                    <Col>
                        <CardDates setDesde={setDesde} desde={desde} setHasta={setHasta} hasta={hasta} />
                    </Col>
                 </Row>
                 <Row className="mb-3 mt-3">
                    <Col><CardTiketsOverview title="Efectivo" number={cuotas.monto_efectivo?cuotas.monto_efectivo:0.0} bgColor="#F5F7FF" blColor="#5A67D8" /></Col>
                    <Col><CardTiketsOverview title="Pagos Tic" number={cuotas.monto_pagos_tic?cuotas.monto_pagos_tic:0.0} bgColor="#FFF5F5" blColor="#F56565"/></Col>
                </Row>
                <Row>
                    <Col><CardTiketsOverview title="debito" number={cuotas.monto_debito?cuotas.monto_debito:0.0} bgColor="#F5F7FF" blColor="#5A67D8" /></Col>
                    <Col><CardTiketsOverview title="transferencia" number={cuotas.monto_transferencia?cuotas.monto_transferencia:0.0} bgColor="#F5F7FF" blColor="#5A67D8" /></Col>    
                </Row>  
                <Row>
                    <Col><CardTiketsOverview title="Credito" number={cuotas.monto_credito?cuotas.monto_credito:0.0} bgColor="#F5F7FF" blColor="#5A67D8" /></Col>
                </Row>
                <Row>
                    <Col>
                        <CardRendimientoPRC data={cuotas}/>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CardTiketsOverview title="Total" number={cuotas.monto_total?cuotas.monto_total:0.0} bgColor="#F5F7FF" blColor="#5A67D8"/>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}
export default Reportes;